// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1JQZZ","badges":"styles_badges__2w5TC"};